import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { TipoFirmante } from '../../../envios/models/tipo-firmante';
import { ConfiguracionFirma, ErroresForm, FirmanteNif, TipoFirma } from '../../models/firmante-nif';
import { DatosConfiguracionDocumentosService } from '../../services/datos-configuracion-documentos.service';
import { DatosDocumentosService } from '../../services/datos-documentos.service';
import { FormularioDocumentoService } from '../../services/formulario-documento.service';
import { FormularioValidacionesDocsService } from '../../services/formulario-validaciones-docs.service';
import { Router } from '@angular/router';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { FormularioEnvioService } from '../../../envios/services/formulario-envio.service';
import { TipoDocumento, TipoDocumentoClass } from '../../models/tipo-documento';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { ExtraInfoCasillasCamposService } from '../../services/extra-info-casillas-campos.service';
import { ConfiguracionDocumentoUploadComponent } from '../configuracion-documento-upload/configuracion-documento-upload.component';
import { filter, finalize, take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SpinnerModalSqpComponent } from 'src/app/shared/components/sqp-components/sqpModales/spinner-modal-sqp/spinner-modal-sqp.component';

@Component({
  selector: 'app-configuracion-documento-page',
  templateUrl: './configuracion-documento-page.component.html',
  styleUrls: ['./configuracion-documento-page.component.css']
})
export class ConfiguracionDocumentoPageComponent implements OnInit, OnDestroy {

  // ---------------------------------------------------------------------------
  // Estado del wizard y del documento en edición
  // ---------------------------------------------------------------------------

  private destroy$ = new Subject<void>();

  index: number = 1;
  finalizarProceso = false;
  idPdf: string ='';
  nombrePdf: string ='';
  objetoDocumento: any;
  urlDocumento: string = '';
  firmanteSeleccionado: TipoFirmante;
  erroresForm: ErroresForm[];
  tipoFirmaAnteriorConFirmanteArray: any[] = [];
  pdfCargado: boolean;
  idDocumentoEditar: number;
  cambioDoc: boolean = false;
  titulo: string = "Configuración de nuevo documento";
  docCargado:boolean = false;
  iconoDoc: string = '#hs-doc';
  documentoAEditar: TipoDocumento = new TipoDocumentoClass();
  semaforoGuardar: boolean = true;
  urlDocAntigua: string = '';
  semaforoCif: boolean = true;
  semaforoNif: boolean = true;
  fusionable: boolean = false;
  ordenFusion: number = 0;
  private savingSpinnerRef: MatDialogRef<SpinnerModalSqpComponent> | null = null;
  @ViewChild(ConfiguracionDocumentoUploadComponent) uploadComponent: ConfiguracionDocumentoUploadComponent;

  // ---------------------------------------------------------------------------
  // Ciclo de vida y arranque
  // ---------------------------------------------------------------------------

  constructor(public datosDocumentosService: DatosDocumentosService,
              public formularioDocumentoService: FormularioDocumentoService,
              public _snackBar: MatSnackBar,
              public dialog: MatDialog,
              private formularioValidacionesDocsService: FormularioValidacionesDocsService,
              private datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService,
              public router: Router,
              private formularioEnvioService: FormularioEnvioService,
              public extraInfoCasillasCamposService: ExtraInfoCasillasCamposService) {

                this.getTipoFirmaAnterior();
                this.editarDocumento();
               }

  ngOnInit(): void {
    this.formularioDocumentoService.getDocumentosDataAll();
    this.datosDocumentosService.configDoc = true;
    if(this.router.url.includes('editar')) this.titulo = "Editar configuración de documento";
    else this.titulo = "Configuración de nuevo documento";
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.datosDocumentosService.configDoc = false;
    this.formularioDocumentoService.resetFormularioDocumento();
  }

  finCarga(){
    this.docCargado=true;
  }

  // ---------------------------------------------------------------------------
  // Inicialización del formulario y modo edición
  // Escucha datosDocId$ para cargar PDF existente; onPdfLoadComplete monta el form.
  // ---------------------------------------------------------------------------

  editarDocumento(){
    this.datosConfiguracionDocumentosService.datosDocId$
      .pipe(takeUntil(this.destroy$))
      .subscribe((value:any) => {
    const isEmpty = Object.keys(value).length;
      if(isEmpty > 0){
        if(value.idPdf == null){
          this.index = 1;
          this._snackBar.open('El documento asociado está subido en una versión anterior. Vuelva a subir el documento por favor.', 'cerrar', {duration: 4000})
        }else{
          this.getDocumentoTemporal(value.idPdf);
          this.idPdf = value.idPdf;
          this.pdfCargado = true;
        }
        this.idDocumentoEditar = value.idTipoDocumento;
        this.fusionable = value.fusionable == true;
        this.ordenFusion = isNaN(value.ordenFusion) ? 0 : value.ordenFusion;
      }
    })
  }

  onPdfLoadComplete(event: { totalPages: number; totalPagesAntesCambioDoc: number }): void {
    if(event.totalPagesAntesCambioDoc > event.totalPages && this.formularioDocumentoService.checkSiDibujos(event.totalPages)){
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-save2',
          titulo: '¿Deseas cambiar el documento?',
          mensaje:'Hay datos configurados en páginas que no existen en el nuevo documento. Todos los datos configurados se perderán.',
          textoConfirmacion: 'cambiar documento',
          iconoConfirmacion: 'icon-unsaved',
          textoCancelar: 'cancelar'
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          this.formularioDocumentoService.resetFormularioDocumento();
          this.inicializarFormularioDesdePadre(event.totalPages, 0);
        }else{
          this.abrirDocAntiguo(this.formularioDocumentoService.formularioDocumento.value);
        }
      });
      return;
    }

    this.inicializarFormularioDesdePadre(event.totalPages, this.idDocumentoEditar);
  }

  private inicializarFormularioDesdePadre(totalPages: number, idDocumento?: number): void {
    const idAInicializar = idDocumento ?? 0;
    const inicializar = () => {
      this.formularioDocumentoService.totalPages = totalPages;
      this.formularioDocumentoService.inicializaFormularioDoc(idAInicializar);
      this.formularioDocumentoService.formularioDocumento.controls['idPdf'].setValue(this.idPdf);
      this.uploadComponent?.completarCargaFormulario();
    };

    if(this.formularioDocumentoService.documentosCargados){
      inicializar();
      return;
    }

    this.formularioDocumentoService.documentosCargados$
      .pipe(
        filter((cargados: boolean) => cargados === true),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe(() => inicializar());
  }

  //esta función se utiliza cuando cargamos el doc antiguo otra vez, ya que al querer cambiar de documento, el nuevo tenía menos páginas que el anterior y se borrarían todos los dibujos.
  abrirDocAntiguo(event:TipoDocumento){
    this.getDocumentoTemporal(event.idPdf);
    this.idPdf = event.idPdf;
    this.pdfCargado = true;
    this.idDocumentoEditar = event.idTipoDocumento;
    this.fusionable = event.fusionable == true;
    this.ordenFusion = isNaN(event.ordenFusion) ? 0 : event.ordenFusion;
  }

  // ---------------------------------------------------------------------------
  // Subida y carga temporal del PDF
  // ---------------------------------------------------------------------------

  uploadPdf(e: any){
   this.index == 1;
   this.putDocumentoTemporal(e);
  }

  putDocumentoTemporal(data: FileList | any){
    this.datosDocumentosService.putDocumentoTemporal(data).subscribe(
      response => {
        // Limpiar URL previa para que getDocumentoTemporal no skippee por id+url cacheados
        this.urlDocumento = '';
        this.idPdf = response;
        this.getDocumentoTemporal(this.idPdf);
        this.nombrePdf = data[0]?.name;
      },
      error => {
        console.error(error);
        this.pdfCargado = false;
        this.urlDocumento = '';
      }
    )
  }

  getDocumentoTemporal(idPdf:string){
    // 2.0.c — evitar re-fetch GetUrl si el id no cambió y ya hay SAS en memoria
    if (idPdf && idPdf === this.idPdf && this.urlDocumento) {
      return;
    }
    this.datosDocumentosService.getDocumentoTemporal(idPdf).subscribe(
      response => {
        this.urlDocumento = response;
        this.nombrePdf = this.urlDocumento.substring((this.urlDocumento.lastIndexOf('/')+1),this.urlDocumento.indexOf('?'));
        this.index ++;
      },
      error => {
        console.error(error);
        this.pdfCargado = false;
        this.urlDocumento = '';
      }
    );
  }

  onPdfLoadError(): void {
    this.pdfCargado = false;
    this.urlDocumento = '';
    this.index = 1;
    this._snackBar.open(
      'No se ha encontrado el documento asociado. Vuelva a subir el documento.',
      'Cerrar',
      { duration: 4000 }
    );
  }

  cambiarDoc(event:any){
    this.urlDocAntigua = this.urlDocumento;
    this.urlDocumento ='';
    this.index = 1;
    this.pdfCargado = false;
    this.cambioDoc = true;
    this.titulo = "Editar configuración de documento"
  }

  // ---------------------------------------------------------------------------
  // Accesores al FormGroup del servicio (atajos para template y validaciones)
  // ---------------------------------------------------------------------------

  get nombre(){ return this.formularioDocumentoService.formularioDocumento.controls['nombre'] }

  get formFirma(): FormGroup | null {
    return this.firmanteSeleccionado?.codigo
      ? this.formularioDocumentoService.getFirmasGroup(this.firmanteSeleccionado.codigo)
      : null;
  }

  get tipoFirma(){ return this.formFirma?.get('tipoFirma') }

  get tieneTag(){ return this.formFirma?.get('tieneTag') }

  get formularios(){ return (this.formularioDocumentoService.formularioDocumento.get('firmantesNif') as FormArray).at(this.obtenerIndexNifArray()).get('formularios') as FormArray}

  get camposEditables(){ return (this.formularioDocumentoService.formularioDocumento.get('firmantesNif') as FormArray).at(this.obtenerIndexNifArray()).get('camposEditables') as FormArray}

  get generico(){ return this.formularioDocumentoService.formularioDocumento.controls['generico']}

  get esCopiaBasica(){ return this.formularioDocumentoService.formularioDocumento.controls['esCopiaBasica']}

  get firmantesNif(){ return this.formularioDocumentoService.formularioDocumento.get('firmantesNif') as FormArray}

  get esRLT(){ return this.formularioDocumentoService.formularioDocumento.controls['esRLT']}

  get formatoNombreArchivoFirmado(){ return this.formularioDocumentoService.formularioDocumento.controls['formatoNombreArchivoFirmado']}

  get formatoNombreArchivoAuditTrail(){ return this.formularioDocumentoService.formularioDocumento.controls['formatoNombreArchivoAuditTrail']}

  get split(){ return this.formularioDocumentoService.formularioDocumento.controls['split']}

  get copyConfiguracion(){ return this.formularioDocumentoService.formularioDocumento.controls['copyConfiguracion']}

  get idTipoDocOrigen(){ return this.formularioDocumentoService.formularioDocumento.controls['idTipoDocOrigen']}

  get textoFormulario(){return this.formularioDocumentoService.formularioDocumento.controls['textoFormulario']}

  get textoAExcluirFormulario(){return this.formularioDocumentoService.formularioDocumento.controls['textoAExcluirFormulario']}

  // ---------------------------------------------------------------------------
  // Navegación del wizard (index / indexPaso)
  // irDireccion delega en valida_*; guardar() se ejecuta desde Finalizar en index 8.
  // actualizarErroresFormulario() en pasos del panel unificado.
  // ---------------------------------------------------------------------------

  irDireccion(e:string){
    // this.formularioDocumentoService.refrescaDocumento(); //parece que value y controls se actualizan automáticamente, por lo que no hace falta refrescar el formulario
    if(!this.docCargado) return;
    if(e=='Siguiente'){
      this.validaSiguiente(e);
    }
    else if(e=='atras') this.validaAtras(e);
    else if(e=='Finalizar' && this.index === 8) this.validaPanelUnificadoFinalizar();
  }

  validaSiguiente(direccion: string){
    switch(this.index){
      case 2:
        this.valida_2();
        break
      case 4:
        this.valida_4();
        break
      case 5:
        this.valida_5();
        break
      case 6:
        this.valida_6();
        break
      case 7:
        this.valida_7(direccion);
        break
      case 8:
        this.valida_8(direccion);
        break
      default:
        this.avanzar();
        break
    }
  }

  validaAtras(direccion:string){
    switch(this.index){
      case 7:
        this.valida_7(direccion);
        break
      case 8:
        this.valida_8(direccion);
        break
      default:
        this.retroceder();
        break
    }
  }

  avanzar(){
    this.index++;
    if (this.index === 8) {
      this.alEntrarPasoFirmas();
    }
    this.formularioDocumentoService.indexPaso = this.index;
    this.formularioDocumentoService.updateObjetoPredicate();
  }

  retroceder(){
    this.index--;
    if (this.index === 8) {
      this.alEntrarPasoFirmas();
    }
    this.formularioDocumentoService.indexPaso = this.index;
    this.formularioDocumentoService.updateObjetoPredicate();
    if(this.index == 2){
      this.copyConfiguracion.setValue(false);
      this.idTipoDocOrigen.setValue(null);
    }
    if(this.index == 3 && this.copyConfiguracion.value == false){
      this.generico.reset();
      }
  }

  irAIndex(indice:number){
    this.index = indice;
    if (this.index === 8) {
      this.alEntrarPasoFirmas();
    }
    this.formularioDocumentoService.indexPaso = this.index;
    this.formularioDocumentoService.updateObjetoPredicate();
  }

  private alEntrarPasoFirmas(): void {
    this.firmanteSeleccionado = {} as TipoFirmante;
    this.erroresForm = [];
    this.datosConfiguracionDocumentosService.resetAbrirFirmantePanel();
    this.inicializarTipoFirmaAnteriorDesdeFormulario();
  }

  /** Snapshot de tipoFirma/tieneTag al entrar en paso 8 (base para detectar cambios al salir). */
  private inicializarTipoFirmaAnteriorDesdeFormulario(): void {
    this.tipoFirmaAnteriorConFirmanteArray = this.firmantesNif.controls.map((ctrl) => {
      const firmanteGroup = ctrl as FormGroup;
      const firmas = firmanteGroup.get('firmas') as FormGroup;
      return {
        tipoFirmante: firmanteGroup.get('tipoFirmante')?.value as TipoFirmante,
        tipoFirma: firmas?.get('tipoFirma')?.value as TipoFirma,
        tieneTag: firmas?.get('tieneTag')?.value,
      };
    });
    this.datosConfiguracionDocumentosService.transferirTipoFirma(this.tipoFirmaAnteriorConFirmanteArray);
  }

  getIndex(event: any){
    this.index = event;
  }

  // ---------------------------------------------------------------------------
  // Validación por paso del wizard
  // Cada valida_N corresponde al panel lateral activo (index). RLT: valida_2 / valida_8. Palabras: overlay y validaPanelUnificadoFinalizar.
  // ---------------------------------------------------------------------------

  valida_2(){
    this.nombre.markAsTouched();
    this.nombre.updateValueAndValidity();
    if(this.nombre.invalid) {
      this._snackBar.open('Hay errores en el nombre de documento.', 'Cerrar', {duration: 4000});
    } else {
      if(this.esRLT.value) this.irAIndex(8);
      else this.avanzar();
    }
  }

  valida_4(){
    this.formularioDocumentoService.indexPaso = this.index;
    this.generico.markAsTouched();
    this.generico.updateValueAndValidity();
    if(this.generico.invalid) {
      this._snackBar.open('Hay errores en como identificar el firmante principal.', 'Cerrar', {duration: 4000});
    } else {
      this.avanzar();
    }
  }

  valida_5(){
    if(this.formatoNombreArchivoFirmado.invalid ||
    this.formatoNombreArchivoAuditTrail.invalid ||
    this.split.invalid ||
    this.esCopiaBasica.invalid ||
    this.textoFormulario.invalid ||
    this.textoAExcluirFormulario.invalid) this._snackBar.open('Hay errores en la configuración avanzada del documento.', 'Cerrar', {duration: 4000});
    else{
      if(this.generico.value) this.irAIndex(7);
      else this.avanzar();
    }
  }

  valida_6(){
    if(!this.semaforoCif) this._snackBar.open(`Debe esperar a que se cargue el CIF para poder avanzar.`, 'Cerrar', { duration: 4000 });
    else if(this.formularioDocumentoService.formularioDocumento.controls['posicionCif'].invalid ||
       this.formularioDocumentoService.formularioDocumento.controls['cifOrden'].invalid ||
       this.formularioDocumentoService.formularioDocumento.controls['cifPage'].invalid ||
       this.formularioDocumentoService.formularioDocumento.controls['cifFormulario'].invalid ||
       this.datosConfiguracionDocumentosService.nohayCif === true) this._snackBar.open(`Hay errores en la configuración del CIF.`, 'Cerrar', { duration: 4000 });
    else this.avanzar();
  }

  valida_7(direccion:string){
    switch(direccion){
      case 'Siguiente':
        if(this.formularioDocumentoService.formularioDocumento.controls['firmantesNif'].value.length === 0) {
          this._snackBar.open('Debe seleccionar como mínimo un firmante.', 'cerrar', {duration: 4000})
          return
        }else if(!this.semaforoNif){
          this._snackBar.open(`Debe esperar a que se carguen los NIF para poder avanzar.`, 'Cerrar', { duration: 4000 });
          return
        }
        if(this.validacionesGlobales_8()) {
          this._snackBar.open(`Hay errores en la configuración del NIF.`, 'Cerrar', {duration: 4000});
          return;
        }else if(!this.generico.value && this.datosConfiguracionDocumentosService.noExistenNifs?.includes(true)) this._snackBar.open(`Hay errores en la configuración del NIF.`,'Cerrar', {duration: 4000});
        else{
          // this.renombrarFirmantesAdicionales();
          this.avanzar();
        }
        break
      case 'atras':
        if(this.generico.value) this.irAIndex(5);
        else
        this.retroceder();
        break
    }
  }

  valida_8(direccion: string){ // Firmas + formularios + campos (panel unificado)
    switch(direccion){
      case 'Siguiente':
      case 'Finalizar':
        this.validaPanelUnificadoFinalizar();
        break
      case 'atras':
        this.resetAllFirmantesIfTipoFirmaCambiado();
        if(this.esRLT.value) this.irAIndex(2);
        else if(this.firmantesNif.at(0).get('nifPage').value==0) this.irAIndex(5);
        else this.retroceder();
        break
    }
  }

  validaPanelUnificadoFinalizar(): void {
    if (!this.formularioDocumentoService.todosFirmantesConFirmaCompleta()) {
      return;
    }
    this.resetAllFirmantesIfTipoFirmaCambiado();
    if (this.firmanteSeleccionado) {
      this.firmanteSeleccionado = {} as TipoFirmante;
    }
    this.formularioDocumentoService.firmantesNif.markAllAsTouched();
    this.formularioDocumentoService.formularioDocumento.updateValueAndValidity();
    this.formularioDocumentoService.formularioDocumento.controls['firmantesNif'].updateValueAndValidity();
    if (this.formularioDocumentoService.formularioDocumento.controls['firmantesNif'].invalid) {
      this.actualizarErroresFormulario();
      this._snackBar.open(
        'Hay errores en la información de los firmantes.',
        'Cerrar',
        { duration: 4000 }
      );
      return;
    }
    if (!this.ejecutarValidacionFormularios()) {
      return;
    }
    if (this.extraInfoCasillasCamposService.formularioPalabras?.invalid) {
      this._snackBar.open(`Hay errores en la información de tipo de contenido.`, 'Cerrar', { duration: 4000 });
      return;
    }
    if (this.extraInfoCasillasCamposService.formularioCampos?.invalid) {
      this._snackBar.open(`Hay errores en la información de los campos editables.`, 'Cerrar', { duration: 4000 });
      return;
    }
    this.guardar();
  }

  private ejecutarValidacionFormularios(): boolean {
    this.formularioValidacionesDocsService.refrescarErroresNombreFormularioDuplicadoGlobal();
    if (this.formularioValidacionesDocsService.hayErroresNombreFormularioDuplicadoGlobal()) {
      this.formularioValidacionesDocsService.marcarNombresFormularioDuplicadosComoTouched();
      if (this.formularioValidacionesDocsService.hayErroresNombreFormularioDuplicadoEntreFirmantes()) {
        this._snackBar.open(`Hay errores en los nombres de formulario (duplicados entre firmantes).`, 'Cerrar', { duration: 4000 });
      } else {
        this._snackBar.open(`Hay errores en los nombres de formulario (duplicados).`, 'Cerrar', { duration: 4000 });
      }
      return false;
    }
    if (this.hayNombreFormularioConLongitudInvalida()) {
      this.marcarNombresFormularioConLongitudInvalidaComoTouched();
      this._snackBar.open(`Hay errores en los nombres de formulario (longitud inválida).`, 'Cerrar', { duration: 4000 });
      return false;
    }
    this.formularioDocumentoService.pruneBorradoresVaciosSinNombre();
    const incompletos = this.formularioDocumentoService.getFormulariosIncompletosPaso10();
    const error: string[] = [];
    const porFirmante = new Map<string, string[]>();
    incompletos.forEach((item) => {
      const lista = porFirmante.get(item.firmanteDesc) ?? [];
      lista.push(item.nombre);
      porFirmante.set(item.firmanteDesc, lista);
    });
    porFirmante.forEach((nombres, firmanteDesc) => {
      error.push(`${firmanteDesc} (${nombres.join(', ')})`);
    });
    if (error.length > 0) {
      this._snackBar.open(
        `Se tiene que añadir al menos una casilla en el formulario: ${error.join(', ')}.`,
        'cerrar',
        { duration: 5000 }
      );
      return false;
    }
    if (this.extraInfoCasillasCamposService.formularioCasillas?.invalid) {
      this._snackBar.open(`Hay errores en la información de las casillas.`, 'Cerrar', { duration: 4000 });
      return false;
    }
    return true;
  }

  valida_10(direccion: string){
    let error = [];
    this.formularioValidacionesDocsService.refrescarErroresNombreFormularioDuplicadoGlobal();
    if (this.formularioValidacionesDocsService.hayErroresNombreFormularioDuplicadoGlobal()) {
      this.formularioValidacionesDocsService.marcarNombresFormularioDuplicadosComoTouched();
      if (this.formularioValidacionesDocsService.hayErroresNombreFormularioDuplicadoEntreFirmantes()) {
        this._snackBar.open(`Hay errores en los nombres de formulario (duplicados entre firmantes).`,'Cerrar', {duration: 4000});
      } else {
        this._snackBar.open(`Hay errores en los nombres de formulario (duplicados).`,'Cerrar', {duration: 4000});
      }
      return;
    }
    if(this.hayNombreFormularioConLongitudInvalida()){
      this.marcarNombresFormularioConLongitudInvalidaComoTouched();
      this._snackBar.open(`Hay errores.`,'Cerrar', {duration: 4000});
      return;
    }
    this.formularioDocumentoService.pruneBorradoresVaciosSinNombre();
    const incompletos = this.formularioDocumentoService.getFormulariosIncompletosPaso10();
    const porFirmante = new Map<string, string[]>();
    incompletos.forEach((item) => {
      const lista = porFirmante.get(item.firmanteDesc) ?? [];
      lista.push(item.nombre);
      porFirmante.set(item.firmanteDesc, lista);
    });
    porFirmante.forEach((nombres, firmanteDesc) => {
      error.push(`${firmanteDesc} (${nombres.join(', ')})`);
    });
    if (error.length > 0) {
      this._snackBar.open(
        `Se tiene que añadir al menos una casilla en el formulario: ${error.join(', ')}.`,
        'cerrar',
        { duration: 5000 }
      );
      return;
    }
    if(this.extraInfoCasillasCamposService.formularioCasillas?.invalid){
      this._snackBar.open(`Hay errores en la información de las casillas.`,'Cerrar', {duration: 4000});
    }else{
      if(this.firmanteSeleccionado){
        this.firmanteSeleccionado = {} as TipoFirmante;
      }
      if(direccion=='Siguiente') this.avanzar();
      if(direccion=='atras'){
        if(this.firmantesNif.at(0).get('nifPage').value==0) this.irAIndex(6);
        else this.retroceder();
      }
    }
  }

  validacionesGlobales_8():boolean{
    let errorArray = [];
    let permiteSinNif = (this.generico.value || this.esCopiaBasica.value)
    this.formularioDocumentoService.firmantesNif.controls.map((x: any, indexX:number)=>{
      let error = false;
      let nifPage = x.controls['nifPage'];
      let nifOrden = x.controls['nifOrden'];
      let nifFormulario = x.controls['nifFormulario'];
      let posicionNif = x.controls['posicionNif'];
      nifPage.setErrors(null);
      nifOrden.setErrors(null);
      nifFormulario.setErrors(null);
      posicionNif.setErrors(null);
      if(posicionNif.value==null){
        posicionNif.setErrors({validadoresPosicionNifRequired: true});
        error=true;
      }
      if(posicionNif.value=='pagina'){
        if(nifPage.value==null || nifOrden.value==null){
          nifPage.setErrors({validadoresNifRequired: true});
          nifOrden.setErrors({validadoresNifRequired: true})
          error=true;
        }
        // if(nifOrden.value==null){
        //   nifOrden.setErrors({validadoresNifRequired: true})
        //   error=true
        // }
        else if(nifPage.value<1 || nifPage.value > this.formularioDocumentoService.totalPages ){
          nifPage.setErrors({validadoresNifTotalPages: true})
          error=true
        }else if(nifOrden.value<1 && !permiteSinNif){
          nifOrden.setErrors({validadoresNifMin: true})
          error=true
        }
      }else if(posicionNif.value=='formulario' && nifFormulario.value==null){
        nifFormulario.setErrors({validadoresNifFormulario: true})
        error=true
      }
      // if(!this.generico.value && !this.esCopiaBasica.value){
      if(!this.generico.value){
        this.formularioDocumentoService.firmantesNif.controls.forEach((y: any, indexY:number)=>{
          let nifPageY = y.controls['nifPage'];
          let nifOrdenY = y.controls['nifOrden'];
          let nifFormularioY = y.controls['nifFormulario'];
          if(indexX!==indexY &&
            nifPage.value==nifPageY.value &&
            nifOrden.value==nifOrdenY.value &&
            nifOrden.value!==null &&
            nifPage.value!==null){
            nifPage.setErrors({validadoresNifduplicado: true})
            nifOrden.setErrors({validadoresNifduplicado: true})
            error=true
          }else if(indexX!==indexY &&
                   nifFormulario.value==nifFormularioY.value &&
                   nifFormulario.value!==null){
                   nifFormulario.setErrors({validadoresFormularioNifduplicado: true})
           }
        })
      }
      errorArray.push(error)
    })
    this.formularioDocumentoService.formularioDocumento.controls['firmantesNif']=this.formularioDocumentoService.firmantesNif
    return errorArray.includes(true)
  }

  // ---------------------------------------------------------------------------
  // Helpers paso 10 — nombres de formulario / casillas
  // ---------------------------------------------------------------------------

  private hayNombreFormularioConLongitudInvalida(): boolean {
    return this.formularioDocumentoService.formulariosBorradorFormArray.controls.some((ctrl) => {
      const nombre = `${(ctrl as FormGroup).get('nombre')?.value ?? ''}`.trim();
      return nombre.length > 22;
    });
  }

  private marcarNombresFormularioConLongitudInvalidaComoTouched(): void {
    this.formularioDocumentoService.formulariosBorradorFormArray.controls.forEach((ctrl) => {
      const nombreControl = (ctrl as FormGroup).get('nombre');
      const nombre = `${nombreControl?.value ?? ''}`.trim();
      if (nombre.length > 22) {
        nombreControl?.markAsTouched();
        nombreControl?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Firmas — paso 8
  // ---------------------------------------------------------------------------

  //conseguimos el valor de tipoFirma antes de que cambie para poder compararlo con el de después.
  public getTipoFirmaAnterior(){
    this.datosConfiguracionDocumentosService.datosTipoFirma$.subscribe(value => {
      this.tipoFirmaAnteriorConFirmanteArray = value;
    })
  }

  resetIfTipoFirmaCambiado(){
    if (this.firmanteSeleccionado?.codigo) {
      this.applyTipoFirmaCambioForFirmante(this.firmanteSeleccionado.codigo);
    }
  }

  resetAllFirmantesIfTipoFirmaCambiado(){
    this.firmantesNif.controls.forEach((ctrl) => {
      const codigo = (ctrl as FormGroup).get('tipoFirmante')?.value?.codigo as string;
      if (codigo) {
        this.actualizarTipoFirmaAnterior(codigo);
      }
    });
    this.tipoFirmaAnteriorConFirmanteArray.forEach((x) => {
      if (x?.tipoFirmante?.codigo) {
        this.applyTipoFirmaCambioForFirmante(x.tipoFirmante.codigo, x);
      }
    });
  }

  private actualizarTipoFirmaAnterior(firmanteCodigo: string): void {
    const formFirma = this.formularioDocumentoService.getFirmasGroup(firmanteCodigo);
    const firmante = (this.formularioDocumentoService.firmantesNif.value as FirmanteNif[]).find(
      (f) => f.tipoFirmante.codigo === firmanteCodigo
    )?.tipoFirmante;
    if (!formFirma || !firmante) {
      return;
    }
    const entrada = {
      tipoFirmante: firmante,
      tipoFirma: formFirma.get('tipoFirma')?.value,
      tieneTag: formFirma.get('tieneTag')?.value,
    };
    const indice = this.tipoFirmaAnteriorConFirmanteArray.findIndex(
      (x) => x.tipoFirmante?.codigo === firmanteCodigo
    );
    if (indice >= 0) {
      this.tipoFirmaAnteriorConFirmanteArray[indice] = entrada;
    } else {
      this.tipoFirmaAnteriorConFirmanteArray.push(entrada);
    }
    this.datosConfiguracionDocumentosService.transferirTipoFirma(this.tipoFirmaAnteriorConFirmanteArray);
  }

  private applyTipoFirmaCambioForFirmante(firmanteCodigo: string, snapshot?: { tipoFirma: TipoFirma; tieneTag: boolean }){
    const formFirma = this.formularioDocumentoService.getFirmasGroup(firmanteCodigo);
    if (!formFirma) {
      return;
    }
    const anterior = snapshot ?? this.tipoFirmaAnteriorConFirmanteArray.find(
      (x) => x.tipoFirmante.codigo === firmanteCodigo
    );
    if (!anterior) {
      return;
    }
    const tipoActual = formFirma.get('tipoFirma')?.value as TipoFirma;
    const tieneTagActual = formFirma.get('tieneTag')?.value;
    const firmante = (this.formularioDocumentoService.firmantesNif.value as FirmanteNif[]).find(
      (f) => f.tipoFirmante.codigo === firmanteCodigo
    )?.tipoFirmante;
    if (!firmante) {
      return;
    }

    if (anterior.tipoFirma !== tipoActual) {
      this.formularioDocumentoService.clearFirmasPdfOnTipoChange(
        firmanteCodigo,
        anterior.tipoFirma,
        tipoActual
      );
      // La limpieza de campos al cambiar tipoFirma ya ocurre en onTipoFirmaChanged del panel.
      // No resetear aquí: un snapshot desactualizado borraba nombreCertificado al salir del paso 9.
      if (tipoActual === TipoFirma.Validador) {
        this.formularioDocumentoService.clearFormulariosYCamposOnValidador(firmanteCodigo);
      }
    }

    if (tieneTagActual === true) {
      this.datosConfiguracionDocumentosService.transferirArrayFirmasVacio(firmante);
      while ((formFirma.controls['posicionFirmas'] as FormArray).length !== 0) {
        (formFirma.controls['posicionFirmas'] as FormArray).removeAt(0);
      }
    }
  }

  //recogemos el firmante seleccionado desde configuracion-documento-configurar-firma para después pasárselo al hijo configuracion-documento-upload y muestre solo las firmas del firmante seleccionado
  getFirmanteSeleccionado(event: TipoFirmante){
    this.firmanteSeleccionado = event;
  }

  obtenerIndexNifArray():number{
    return this.formularioDocumentoService.firmantesNif.value.findIndex((x:FirmanteNif) => x.tipoFirmante.codigo == this.firmanteSeleccionado.codigo)
  }

  // ---------------------------------------------------------------------------
  // Errores globales en panel unificado (firmas / formularios)
  // Alimenta [erroresForm] para que los hijos marquen el firmante con error.
  // ---------------------------------------------------------------------------

  actualizarErroresFormulario(): void {
    if(!this.semaforoGuardar) return;
    this.formularioDocumentoService.formularioDocumento.markAllAsTouched();
    this.refreshForm();
    if(this.formularioDocumentoService.formularioDocumento.invalid){
      this.erroresForm = this.formularioValidacionesDocsService.getFormValidationErrors();
    }
  }

  // ---------------------------------------------------------------------------
  // Guardado (Finalizar en paso 8) y salida del wizard
  // Se invoca desde validaPanelUnificadoFinalizar() o abrirModalConfirmacion.
  // ---------------------------------------------------------------------------

  guardar(){
    this.actualizarErroresFormulario();
    if(this.formularioDocumentoService.formularioDocumento.invalid){
      return;
    }

    this.objetoDocumento = this.formularioDocumentoService.montarObjetoDocumentoGuardar();
    if(this.index == 8  && this.semaforoGuardar) {
      this.semaforoGuardar = false;
      this.abrirSpinnerGuardado();
      if(this.objetoDocumento.generico) this.objetoDocumento.nombreDocumentoGenerico = this.nombrePdf;
      this.objetoDocumento.fusionable = this.fusionable;
      this.objetoDocumento.ordenFusion = this.ordenFusion;
      this.datosDocumentosService.guardaDocumento(this.objetoDocumento)
      .pipe(
        finalize(() => {
          this.semaforoGuardar = true;
          this.cerrarSpinnerGuardado();
        })
      )
      .subscribe({
        next: (next) => {
          const isEmpty = Object.keys(this.formularioEnvioService.formEnvioTemporal.value).length;
          if(isEmpty > 0){
            let existingDocsArray = this.formularioEnvioService.formularioEnvio.controls['tiposDocumento'].value
            // let indexDoc = existingDocsArray.findIndex((x: TipoDocumento) => x.idTipoDocumento==this.objetoDocumento.idTipoDocumento);
            let indexDoc = existingDocsArray.findIndex((x: TipoDocumento) => x.nombre==this.objetoDocumento.nombre);
            this.objetoDocumento.fusionable = true; //lo marcamos como fusionable para que aparezca en la columna de fusionados en la configuración de dosier, si fuera el caso que estamso añadiendo un doc nuevo.

            if(indexDoc > -1){
              existingDocsArray[indexDoc] = this.objetoDocumento;
            }else{
              this.objetoDocumento.idTipoDocumento = next.IdTipoDocumento;
              existingDocsArray.push(this.objetoDocumento)
            }
            this.formularioEnvioService.addDocumentosEnForm(existingDocsArray);
            this.formularioEnvioService.formEnvioTemporal = this.formularioEnvioService.formularioEnvio;
          }
          this.confirmacionGuardadoOk();

        },
        error: (error) => {
          console.error(error);
          this.dialog.open(ModalMessageComponent, {
            data: {
              mensaje: 'Ha habido un error en guardar la configuración de documento.',
              alert: true
            },
          });
        }
      });
    }
  }

  confirmacionGuardadoOk(){
    this.cerrarSpinnerGuardado();
    this.finalizarProceso = true;
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      data: {
        mensaje: 'Configuración de documento guardada correctamente',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.formularioDocumentoService.resetFormularioDocumento();
      this.datosDocumentosService.refreshDocs = true;
      this.formularioDocumentoService.getDocumentosDataAll();
      this.salirTrasConfiguracionDocumento();
    });
  }

  private salirTrasConfiguracionDocumento(): void {
    const temporal = this.formularioEnvioService.formEnvioTemporal;
    const vieneDesdeEnvio = temporal && Object.keys(temporal.value).length > 0;
    if (vieneDesdeEnvio) {
      const idV3 = temporal.get('idV3TipoEnvio')?.value || '0';
      this.router.navigate(['/panel/configuracion-dosier', idV3]);
      return;
    }
    this.router.navigate(['/panel/documentos-configurados']);
  }

  private abrirSpinnerGuardado(): void {
    if (this.savingSpinnerRef) return;
    this.savingSpinnerRef = this.dialog.open(SpinnerModalSqpComponent, {
      disableClose: true
    });
  }

  private cerrarSpinnerGuardado(): void {
    if (!this.savingSpinnerRef) return;
    this.savingSpinnerRef.close();
    this.savingSpinnerRef = null;
  }

  //forzamos un refresh de las validaciones para recuperar las validaciones reales
  refreshForm(){

    for (const field in this.formularioDocumentoService.formularioDocumento.controls) { // 'field' is a string
      const control = this.formularioDocumentoService.formularioDocumento.get(field); // 'control' is a FormControl

      control.updateValueAndValidity();

    }
  }

  back(){
    if(!this.formularioDocumentoService.hayCambios()){
      this.formularioDocumentoService.resetFormularioDocumento();
      this.salirTrasConfiguracionDocumento();
      this.formularioDocumentoService.totalPages = null;
    }else{
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-save2',
          titulo: 'Deseas salir sin guardar?',
          mensaje:'Se perderán todos los cambios realizados en la configuración del documento',
          // preguntaConfirmacion: '¿Está seguro que desea salir de la configuración de documento sin guardar?',
          textoConfirmacion: 'Salir sin guardar',
          iconoConfirmacion: 'icon-unsaved',
          textoCancelar: 'cerrar'
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          this.formularioDocumentoService.resetFormularioDocumento();
          this.salirTrasConfiguracionDocumento();
          this.formularioDocumentoService.totalPages = null;
        }
      });
    }
  }

  // ---------------------------------------------------------------------------
  // Atajo finalizar sin firmantes (genérico / copia básica)
  // ---------------------------------------------------------------------------

  abrirModalConfirmacion(){
    if(this.formularioDocumentoService.RequiereNif()){
      this._snackBar.open('Debe seleccionar como mínimo un firmante con Página/Orden o Formulario', 'cerrar', {duration: 4000})
    }else{
      let text;
      if(this.generico.value) text = 'un documento genérico y';
      if(this.esCopiaBasica.value) text = 'una copia básica y';
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          // icono: 'icon-tick',
          // titulo: '¿Estás seguro que quieres continuar sin haber indicado ningún firmante?',
          soloMensaje: `Al ser ${text} no haber indicado ningún firmante, la configuración de documento finalizará. ¿Estás seguro que quieres finalizar?`,
          // soloMensaje: '¿Estás seguro que quieres continuar sin haber indicado ningún firmante?',
          textoConfirmacion: 'finalizar',
          iconoConfirmacion: 'icon-tick',
          textoCancelar: 'cancelar'
        },
      });

      dialogRef?.afterClosed().subscribe(result => {
        if(result === 'OK'){
          this.addFirmanteNifVacio();
          // this.index=9;
          // this.irAIndex(10);
          this.irAIndex(8);
          this.guardar();
        }
      })
    }
  }

  addFirmanteNifVacio(){
    let valoresFirmanteNif: FirmanteNif;
    valoresFirmanteNif = {
      tipoFirmante: {
        codigo: '100',
        desc: 'Firmante principal'
      },
      nifPage: 0,
      nifOrden: 0,
      firmas: {} as ConfiguracionFirma,
      formularios: [],
      camposEditables: [],
      nifFormulario:'',
      posicionNif: null
    }
    this.formularioDocumentoService.addFirmanteNifInFormArray(valoresFirmanteNif)
  }

  // ---------------------------------------------------------------------------
  // Semáforos de carga CIF / NIF (spinners en pasos 7 y 8)
  // ---------------------------------------------------------------------------

  spinnerCifIsCargando(event: boolean){
    this.semaforoCif = !event;
  }

  spinnerNifIsCargando(event: boolean){
    this.semaforoNif = !event;
  }

}
